var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"c-battery-list block-zones"},_vm._l((_vm.data),function(battery,id){return _c('rn-battery',{key:("row-" + id),attrs:{"data":battery}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }